import VideoGuestBookContributorBanner from './VideoGuestBookContributorBanner';

export default VideoGuestBookContributorBanner;
